import axios from "axios";
import Cookies from "js-cookie";
axios.defaults.headers.common['Authorization'] = 'Bearer ' + Cookies.get('token');
const instance = axios.create({
 // baseURL: 'https://electoralapp.onrender.com/api/v1',
 //baseURL: 'https://electorappcontrol.vercel.app/api/v1',
 //baseURL: 'elecciones-j65r6p82z-novasoftsolutions-projects.vercel.app'
 // REACT_APP_API_URL permite apuntar a otro backend sin tocar el código
 baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1',
 
  //  withCredentials: true,
  // con señal débil una petición puede quedar colgada: a los 45 s se da por
  // perdida y el registro se guarda en el equipo (ver utils/colaSincronizacion)
  timeout: 45000,
});
export default instance;